import { createMask } from 'imask';

export function maskValue(value, mask) {
  if (!value) return '-';
  if (!mask) return value;
  return createMask({ mask }).resolve(value);
}
